import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentSection, totalSections, sectionTitles }) => {
  const progressPercentage = ((currentSection + 1) / totalSections) * 100;

  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-6">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <Icon name="MapPin" size={16} className="text-primary" />
          <span className="text-sm font-medium text-foreground">
            Step {currentSection + 1} of {totalSections}
          </span>
        </div>
        <span className="text-sm text-muted-foreground">
          {Math.round(progressPercentage)}% Complete
        </span>
      </div>
      {/* Progress Bar */}
      <div className="w-full bg-muted rounded-full h-2 mb-3">
        <div
          className="bg-primary h-2 rounded-full transition-all duration-300 ease-out"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      {/* Current Section Title */}
      <div className="text-sm text-muted-foreground">
        Current: <span className="font-medium text-foreground">{sectionTitles?.[currentSection]}</span>
      </div>
      {/* Section Indicators */}
      <div className="flex items-center justify-between mt-4">
        {sectionTitles?.map((title, index) => (
          <div key={index} className="flex flex-col items-center space-y-1">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium transition-all duration-200 ${
                index <= currentSection
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}
            >
              {index < currentSection ? (
                <Icon name="Check" size={14} />
              ) : (
                index + 1
              )}
            </div>
            <div className="text-xs text-center text-muted-foreground max-w-16 leading-tight">
              {title?.split(' ')?.[0]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;